import { render, staticRenderFns } from "./BlockType23SmallRow.vue?vue&type=template&id=ac8c44de&scoped=true&"
import script from "./BlockType23SmallRow.vue?vue&type=script&lang=ts&"
export * from "./BlockType23SmallRow.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType23SmallRow.vue?vue&type=style&index=0&id=ac8c44de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8c44de",
  null
  
)

export default component.exports